module.exports = "/images/vendor/flag-icon-css/flags/4x3/sl.svg?ddbd1d9b113b2688102f56c63a431475";